<template>
  <div class="mt-component-form">
    <!-- PC 레이아웃 (768px 이상) -->
    <div class="desktop-layout" v-show="!isMobile">
      <vs-row class="my-4 ">
        <h5 style="align-self: center"><i class="dot"></i>장비 정보</h5>
        <div class="ml-auto">
          <vs-button
            v-if="!isPrint && !isReadonly"
            class=""
            color="secondary"
            type="border"
            @click="handleAddRow">항목추가</vs-button>
          <vs-button
            v-if="!isPrint && !isReadonly"
            class="ml-4"
            color="secondary"
            @click="handleRemoveRow">선택삭제</vs-button>
        </div>
      </vs-row>

      <div
        class="grid row-header"
        :class="[isPrint || isReadonly ? 'grid-cols-9' : 'grid-cols-10']"
      >
        <div v-if="!isPrint && !isReadonly" class="col-span-1 row-header__item">
          <vs-checkbox
            v-model="equipAllCheck"
            @change="changeAllCheck"
          ></vs-checkbox>
        </div>
        <div class="col-span-3 row-header__item">장비명</div>
        <div class="col-span-3 row-header__item">제조사 또는 모델명</div>
        <div class="col-span-3 row-header__item">
          장비 규격(정격하중 또는 인양하중 등)
        </div>
      </div>
      <!-- rows -->
      <div
        class="grid row-content"
        :class="[isPrint || isReadonly ? 'grid-cols-9' : 'grid-cols-10']"
        v-for="(rows, indexRows) in equipmentList"
        :key="indexRows"
      >
        <div v-if="!isPrint && !isReadonly" class="col-span-1 none-border-center">
          <vs-checkbox v-model="rows.is_checked"></vs-checkbox>
        </div>
        <div class="col-span-3 item-area">
          <ml-input v-if="!isPrint" rows="1" v-model="rows.name" class="w-full flex-1 p-1" :readonly="isReadonly"/>
          <span v-else class="print-input">{{ rows.name }}</span>
        </div>
        <div class="col-span-3 item-area">
          <ml-input v-if="!isPrint" rows="1" v-model="rows.manufacturer" class="w-full flex-1 p-1" :readonly="isReadonly"/>
          <span v-else class="print-input">{{ rows.manufacturer }}</span>
        </div>
        <div class="col-span-3 item-area">
          <ml-input v-if="!isPrint" rows="1" v-model="rows.standard" class="w-full flex-1 p-1" :readonly="isReadonly"/>
          <span v-else class="print-input">{{ rows.standard }}</span>
        </div>
      </div>
    </div>

    <!-- 모바일 레이아웃 (768px 미만) -->
    <div class="mobile-layout" v-show="isMobile">
      <!-- 모바일 헤더 -->
      <div class="mobile-header">
        <h5 class="mobile-title"><i class="dot"></i> 장비 정보</h5>

        <!-- 전체 선택 영역 -->
        <div v-if="!isPrint && !isReadonly && equipmentList.length > 0" class="mobile-select-all">
          <vs-checkbox
            v-model="equipAllCheck"
            @change="changeAllCheck"
            class="mobile-checkbox"
          />
          <span class="select-all-text" @click="toggleAllCheck">전체 선택 ({{ checkedCount }}/{{ equipmentList.length }})</span>
          <vs-button
            v-if="equipAllCheck && checkedCount === equipmentList.length"
            color="danger"
            type="border"
            size="small"
            @click="handleDeleteAll"
            class="mobile-delete-all-btn"
          >
            전체삭제
          </vs-button>
        </div>
      </div>

      <!-- 빈 목록 표시 -->
      <div v-if="equipmentList.length === 0" class="mobile-empty-card">
        <feather-icon icon="InfoIcon" />
        <p class="empty-text">장비 정보 항목이 존재하지 않습니다.</p>
      </div>

      <!-- 모바일 카드 목록 -->
      <div v-else class="mobile-cards-container">
        <div v-for="(item, index) in equipmentList" :key="index" class="mobile-card">
          <!-- 카드 헤더 -->
          <div class="mobile-card-header">
            <vs-checkbox v-if="!isPrint && !isReadonly" v-model="item.is_checked" class="mobile-checkbox" />
            <span class="card-number" @click="toggleItemCheck(index)">장비 {{ index + 1 }}</span>
            <vs-button v-if="!isPrint && !isReadonly" color="danger" type="border" size="small" @click="handleRemoveSingleRow(index)" class="mobile-delete-btn"> 삭제 </vs-button>
          </div>

          <!-- 장비명 -->
          <div class="mobile-field">
            <label class="mobile-label">장비명</label>
            <div class="mobile-input-container">
              <p v-if="isPrint" class="mobile-print-text">{{ item.name }}</p>
              <ml-input v-else :readonly="isReadonly" v-model="item.name" placeholder="입력" class="mobile-input" />
            </div>
          </div>

          <!-- 제조사 또는 모델명 -->
          <div class="mobile-field">
            <label class="mobile-label">제조사 또는 모델명</label>
            <div class="mobile-input-container">
              <p v-if="isPrint" class="mobile-print-text">{{ item.manufacturer }}</p>
              <ml-input v-else :readonly="isReadonly" v-model="item.manufacturer" placeholder="입력" class="mobile-input" />
            </div>
          </div>

          <!-- 장비 규격 -->
          <div class="mobile-field">
            <label class="mobile-label">장비 규격(정격하중 또는 인양하중 등)</label>
            <div class="mobile-input-container">
              <p v-if="isPrint" class="mobile-print-text">{{ item.standard }}</p>
              <ml-input v-else :readonly="isReadonly" v-model="item.standard" placeholder="입력" class="mobile-input" />
            </div>
          </div>
        </div>
      </div>

      <!-- 모바일 하단 버튼 -->
      <div v-if="!isPrint && !isReadonly" class="mobile-bottom-actions">
        <vs-button color="danger" type="border" :disabled="checkedCount === 0" @click="handleRemoveRow" class="mobile-action-btn"> 선택삭제 ({{ checkedCount }}) </vs-button>
        <vs-button color="primary" @click="handleAddRow" class="mobile-action-btn mobile-add-btn"> 항목추가 </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableEquipment',
  props: {
    list: Array,
    isPrint: Boolean,
    isReadonly: Boolean,
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler (value) {
        if (value && value.length > 0) {
          this.equipmentList = value
        }
      },
    },
    // 개별 체크박스 상태 변경 감지
    equipmentList: {
      deep: true,
      handler(newList) {
        if (newList.length > 0) {
          const allChecked = newList.every(item => item.is_checked);
          const someChecked = newList.some(item => item.is_checked);

          // 모든 항목이 선택되면 전체 선택도 활성화
          if (allChecked && !this.equipAllCheck) {
            this.equipAllCheck = true;
          }
          // 전체 선택이 체크되어 있는 상태에서 개별 항목이 해제되면 전체 선택도 해제
          else if (this.equipAllCheck && !allChecked) {
            this.equipAllCheck = false;
          }
        }
      }
    }
  },
  methods: {
    checkForm (value, indexRows, text) {
      if (value.target.checked) {
        this.$emit('update-list-check', indexRows - 1, text)
      } else {
        this.$emit('update-list-check', indexRows - 1, '')
      }
    },
    // 항목추가
    handleAddRow () {
      this.equipmentList.push({
        is_checked: this.equipAllCheck,
        name: '',
        manufacturer: '',
        standard: '',
      })
      this.updateList()
    },
    // 선택삭제
    handleRemoveRow () {
      for (let i = 0; i < this.equipmentList.length; i++) {
        if (this.equipmentList[i].is_checked) {
          this.equipmentList.remove(this.equipmentList[i])
          i = -1
        }
      }

      this.equipAllCheck = false
      this.updateList()
    },
    // 일괄 체크
    changeAllCheck () {
      for (const data of this.equipmentList) {
        data.is_checked = this.equipAllCheck
      }
    },
    // 전체 선택 레이블 클릭 시 토글
    toggleAllCheck() {
      this.equipAllCheck = !this.equipAllCheck;
      this.changeAllCheck();
    },
    // 개별 아이템 레이블 클릭 시 토글
    toggleItemCheck(index) {
      this.equipmentList[index].is_checked = !this.equipmentList[index].is_checked;
    },
    // 개별 항목 삭제 (모바일용)
    handleRemoveSingleRow(index) {
      this.equipmentList.splice(index, 1);
      this.updateList();
    },
    // 전체삭제
    handleDeleteAll() {
      this.equipmentList = [];
      this.equipAllCheck = false;
      this.updateList();
    },
    // update
    updateList () {
      this.$emit('updateList', this.equipmentList)
    },
  },
  data () {
    return {
      equipAllCheck: false,
      equipmentList: [],
      windowWidth: window.innerWidth,
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768;
    },
    checkedCount() {
      return this.equipmentList.filter(item => item.is_checked).length;
    },
  },
  mounted() {
    // 화면 크기 변경 감지
    this.handleResize = () => {
      this.windowWidth = window.innerWidth;
    };
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  margin: 0;
}

/* Table */
.row-header {
  background-color: $bg;
  text-align: center;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}
.row-header__item {
  border: $border;
  border-left: none;
  border-right: none;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: none;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  border-bottom: $border;
  &__title {
    background-color: $bg;
    height: 100%;
  }
}
.row-content__body-item {
  .item-content {
    padding: 15px;
    border-left: $border;

    pre {
      font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
      white-space: pre-wrap;
    }
  }
  .item-box {
    border-left: $border;
    border-right: $border;
    display: flex;
    .item-box-check {
      flex: 1;
      justify-content: center !important;
    }
    .item-box-check:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
  .item-area {
    padding: 5px;
    align-self: center;
  }
}
.row-content__body-item ~ .row-content__body-item {
  border-top: $border;
}
.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
.row-content-none-data {
  height: 120px;
  border-bottom: $border;
  display: flex;
  justify-content: center;
  align-items: center;
}

// 모바일 레이아웃 스타일
@media (max-width: 767px) {
  .desktop-layout {
    display: none !important;
  }
}

@media (min-width: 768px) {
  .mobile-layout {
    display: none !important;
  }
}

.mobile-layout {
  .mobile-header {
    margin-bottom: 16px;

    .mobile-title {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 12px;
      color: #333;

      .dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #007bff;
        border-radius: 50%;
        margin-right: 8px;
      }
    }

    .mobile-select-all {
      display: flex;
      align-items: center;
      padding: 12px 16px;
      background: #f8f9fa;
      border-radius: 8px;
      border: 1px solid #e9ecef;

      .mobile-checkbox {
        margin-right: 12px;
        justify-content: center !important;

        &::v-deep span {
          margin: 0;
        }
      }

      .select-all-text {
        flex: 1;
        font-size: 14px;
        color: #666;
        font-weight: 500;
        cursor: pointer;
        user-select: none;

        &:hover {
          color: #007bff;
        }
      }

      .mobile-delete-all-btn {
        min-height: 32px;
        font-size: 12px;
        padding: 6px 12px;
        margin-left: 8px;
      }
    }
  }

  .mobile-empty-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    background: #fafafa;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    text-align: center;

    .empty-icon {
      width: 48px;
      height: 48px;
      color: #999;
      margin-bottom: 16px;
    }

    .empty-text {
      color: #999;
      font-size: 16px;
      margin: 0;
    }
  }

  .mobile-cards-container {
    .mobile-card {
      background: white;
      border: 1px solid #e9ecef;
      border-radius: 12px;
      padding: 16px;
      margin-bottom: 16px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

      .mobile-card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 1px solid #e9ecef;

        .mobile-checkbox {
          margin-right: 12px;
          justify-content: center !important;

          &::v-deep span {
            margin: 0;
          }
        }

        .card-number {
          flex: 1;
          font-size: 14px;
          font-weight: 600;
          color: #333;
          cursor: pointer;
          user-select: none;

          &:hover {
            color: #007bff;
          }
        }

        .mobile-delete-btn {
          min-height: 32px;
          font-size: 12px;
          padding: 6px 12px;
        }
      }

      .mobile-field {
        margin-bottom: 16px;

        .mobile-label {
          display: block;
          font-size: 13px;
          font-weight: 600;
          color: #333;
          margin-bottom: 6px;
        }

        .mobile-input-container {
          .mobile-print-text {
            font-size: 14px;
            color: #555;
            line-height: 1.5;
            margin: 0;
            word-break: break-word;
          }

          .mobile-input {
            width: 100%;
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .mobile-bottom-actions {
    display: flex;
    gap: 12px;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 8px;
    margin-top: 16px;

    .mobile-action-btn {
      flex: 1;
      min-height: 44px;
      font-size: 14px;
      font-weight: 600;

      &.mobile-add-btn {
        background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
        color: white;
        border: none;
      }
    }
  }
}
</style>
